import React, { useState, useEffect } from "react";
import MainNavbar from "./shared/MainNavbar.jsx";
import MainFooter from "./shared/MainFooter.jsx";
import MainHero from "./sections/MainHero.jsx";
import MiddleSectionsCollapsible from "./sections/MiddleSectionsCollapsible.jsx";
import FieldProofSection from "./sections/FieldProofSection.jsx";
import PlugPlaySection from "./sections/PlugPlaySection.jsx";
import CustomAgentSection from "./sections/CustomAgentSection.jsx";
import StickyMobileBar from "./mobile/StickyMobileBar.jsx";
import CustomAgentModal from "./modal/CustomAgentModal.jsx";

const MainLanding = () => {
  const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);
  const [showStickyBar, setShowStickyBar] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowStickyBar(window.scrollY > 400);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const openCustomModal = () => setIsCustomModalOpen(true);
  const closeCustomModal = () => setIsCustomModalOpen(false);

  return (
    <div
      className={`choice-landing min-h-screen bg-[#080b14] noise-overlay ${showStickyBar ? "pb-20 md:pb-0" : ""}`}
      data-testid="choice-page"
    >
      <MainNavbar />
      <MainHero onOpenCustomModal={openCustomModal} />
      <MiddleSectionsCollapsible />
      <FieldProofSection />
      <PlugPlaySection />
      <CustomAgentSection onOpenModal={openCustomModal} />
      <MainFooter />
      <StickyMobileBar visible={showStickyBar} onOpenCustomModal={openCustomModal} />
      <CustomAgentModal isOpen={isCustomModalOpen} onClose={closeCustomModal} />
    </div>
  );
};

export default MainLanding;
